// 引入 axios 
import axios from "axios";
// 创建 axios 实例
const request = axios.create({
  // https://yanmingsw.com:97/Web
  baseURL:"https://yanmingsw.com:97/Web", // 设置请求的基准 URL
  timeout: 5000, // 设置超时时间
//   headers: {
//     "Content-Type": "application/json", // 默认请求头
//   },
});
// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 例如：添加 token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error("请求拦截器错误：", error);
    return Promise.reject(error);
  });
// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response.data; // 返回响应数据
  },
  (error) => {
    // 对响应错误做点什么
    console.error("响应拦截器错误：", error);
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      console.error("服务器响应错误：", error.response.status);
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error("请求未收到响应：", error.request);
    } else {
      // 在设置请求时发生了一些事情，触发了一个错误
      console.error("请求配置错误：", error.message); 
 }
       return Promise.reject(error);
  });

  export const getBannerImage = async () => {
    try {
        const response = await request.post('/showSlideShowOne'); // 使用 post 请求
        return response;  // 返回响应
    } catch (error) {
        console.error('获取部门数据失败:', error);  // 错误处理
        throw error;  // 抛出错误
    }
  };
  export const getDepartments = async () => {
    try {
        const response = await request.post('/showDepartment'); // 使用 post 请求
        return response;  // 返回响应
    } catch (error) {
        console.error('获取部门数据失败:', error);  // 错误处理
        throw error;  // 抛出错误
    }
  };
  
export const getBannerShow = async () => {
  try {
      const response = await request.post('/showSlideShow'); // 使用 post 请求
      return response;  // 返回响应
  } catch (error) {
      console.error('获取Banner图失败:', error);  // 错误处理
      throw error;  // 抛出错误
  }
};
export const getCompony = async () => {
  try {
      const response = await request.post('/showContact'); // 使用 post 请求
      return response;  // 返回响应
  } catch (error) {
      console.error('获取公司信息数据失败:', error);  // 错误处理
      throw error;  // 抛出错误
  }
};
export const getAllNews = async () => {
  try {
      const response = await request.post('/showAllNews'); // 使用 post 请求
      return response;  // 返回响应
  } catch (error) {
      console.error('获取新闻数据失败:', error);  // 错误处理
      throw error;  // 抛出错误
  }
};
export const getAllMember = async () => {
  try {
      const response = await request.post('/showAllMember'); // 使用 post 请求
      return response;  // 返回响应
  } catch (error) {
      console.error('获取精英数据失败:', error);  // 错误处理
      throw error;  // 抛出错误
  }
};
export const getAllProKind= async () => {
  try {
      const response = await request.post('/showAllProductKind'); // 使用 post 请求
      return response;  // 返回响应
  } catch (error) {
      console.error('获取产品种类失败:', error);  // 错误处理
      throw error;  // 抛出错误
  }
};export const getAllMemberKind= async () => {
  try {
      const response = await request.post('/showMemberKind'); // 使用 post 请求
      return response;  // 返回响应
  } catch (error) {
      console.error('获取精英种类失败:', error);  // 错误处理
      throw error;  // 抛出错误
  }
};
export const getProcess= async () => {
  try {
      const response = await request.post('/showProcess'); // 使用 post 请求
      return response;  // 返回响应
  } catch (error) {
      console.error('获取发展历程失败:', error);  // 错误处理
      throw error;  // 抛出错误
  }
};export const getSlidePhoto= async () => {
  try {
      const response = await request.post('/showAllPhoto'); // 使用 post 请求
      return response;  // 返回响应
  } catch (error) {
      console.error('获取首页轮播图失败:', error);  // 错误处理
      throw error;  // 抛出错误
  }
};
export default request;